<div class="track-container"
	[ngStyle]="{ 'grid-template-rows': !trackCollapsed? 'repeat(' + (animateConfig?.length +1) + ', 24px)' : 'none'}"
	[class.is-open]="!trackCollapsed"
	[class.is-collapsed]="trackCollapsed"
	[class.is-track-group]="track?.tracks"
	[class.is-track]="!track?.tracks"
	[class.is-selected]="selectedTrackIds?.indexOf(track?.id) > -1"
	[class.currently-in-time]="currentlyInTime"
	[class.is-hovered]="isTrackHovered(track) || groupHovered || widgetInClosedGroupHovered"
	[class.timepoint-dragging]="timepointDragging"
	[class.track-element-dragging]="trackElementDragging"
	(mouseover)="onTrackMouseOver(track, $event)"
	(mouseleave)="onTrackMouseLeave()"
>
<div class="track-overlay"></div>
	<div 
		class="info" 
		[ngClass]="{'track-in-group': type === 'trackInGroup' || type === 'trackFromApp'}"
		>
		<div *ngIf="(type === 'trackGroup' || widget?.type === 'app') && (!hiddenTracks || hiddenTracks?.length === 0)" class="label-wrapper"
			(mouseup)="groupCollapseMouseEvent($event)"
			(mousedown)="groupCollapseMouseEvent($event)"
			(click)="groupCollapseClick($event)">
			<span class="item-toggle">
				<i class="fas fa-caret-right" [style.display]="!groupCollapsed ? 'none' : 'inline-block'"></i>
				<i class="fas fa-caret-down" [style.display]="groupCollapsed ? 'none' : 'inline-block'"></i>
			</span>
			<label *ngIf="type === 'trackGroup'" class="icon-label">
				<i class="fa fa-folder"></i>
			</label>
			<label 
				*ngIf="widget?.type === 'app'"
				class="icon-label" 
				[innerHTML]="widget?.type | widgetIcon">
			</label>
		</div>
		<div *ngIf="(type === 'trackGroup' || widget?.type === 'app') && hiddenTracks?.length && hiddenTracks?.indexOf(track.id) === -1" class="label-wrapper">
			<span class="item-toggle">
				<i class="fas fa-caret-down"></i>
			</span>
			<label *ngIf="type === 'trackGroup'" class="icon-label">
				<i class="fa fa-folder"></i>
			</label>
			<label 
				*ngIf="widget?.type === 'app'"
				class="icon-label" 
				[innerHTML]="widget?.type | widgetIcon">
			</label>
		</div>
		<div *ngIf="(type === 'track' && widget?.type !== 'app') || type === 'trackInGroup' || type === 'trackFromApp'" class="label-wrapper"
			(mouseup)="groupCollapseMouseEvent($event)"
			(mousedown)="groupCollapseMouseEvent($event)"
			(click)="trackCollapseClick($event)">
			<span *ngIf="interactivityEditorService.parentEntityType !== 'App'" class="item-toggle" [style.visibility]="animateConfig && animateConfig?.length > 0 ? 'visible' : 'hidden'">
				<i class="fa fa-angle-right" [style.display]="trackCollapsed ? 'inline-block' : 'none'"></i>
				<i class="fa fa-angle-down" [style.display]="trackCollapsed ? 'none' : 'inline-block'"></i>
			</span>
			<label 
				class="icon-label" 
				[innerHTML]="widget?.type | widgetIcon">
			</label>
		</div>	
	
		<div *ngIf="type !== 'trackFromApp'" class="input-wrapper" (click)="onInputWrapperClicked()">
			<input 
				#labelInput
				class="label-input" 
				type="text" 
				[formControl]="labelControl"
				(focus)="onFocusLabelInput()"
				(blur)="onBlurLabelInput()"
				(change)="onLabelInputChange($event, labelControl.value)"
				(keydown)="onLabelInputKeyDown($event, labelControl.value)" />
		</div>
		<div *ngIf="type === 'trackFromApp'" class="input-wrapper">
			<span>{{ widget?.label }}</span>
		</div>
		<div class="vertical-drag-area"></div>
		<div
		*ngIf="stageWidgets?.length || (widget && widget.type !== 'timer' && widget.type !== 'audio')" 
		class="ie-icon-button no-hover" [title]="visibleStageWidgets?.length + ' - all: ' + stageWidgets?.length" [class.active]="stageWidgets?.length && visibleStageWidgets?.length === stageWidgets?.length || widget?.visibility === 'visible'" (click)="stageWidgets?.length ? toggleGroupVisibility(track) : toggleWidgetVisibility(widget)">
			<i class="fa fa-eye"></i>
		</div>

	</div>
	<div 
		*ngIf="type === 'trackGroup'; else trackContainer" 
		class="group-track-element">
	</div>
	<ng-template #trackContainer>
		<div 
			[class.endscreen-enabled]="endscreenEnabled"
			class="element-container" 
			*ngIf="duration && track && track['inOutPoints']">
			<div class="bb-track-zoom" #trackElementContainer>
				<canvas #backgroundCanvas [hidden]="!canvasVisible"></canvas>
				<ng-container *ngFor="let ioPoint of track['inOutPoints']; trackBy: trackByForTrack">
					<timepoint 
						[dragger]="'none'"
						[maxTime]="duration"
						[tooltip]="leftData < 56 ? 'hide' : 'left'"
						[timepoint]="ioPoint.inpointTMP || ioPoint.inpoint"
						[widgetConfig]="widget?.config"
						[style.left]="tooltipLeftOffset( ioPoint.inpointTMP || ioPoint.inpoint )"
						[class.track-selected]="selectedTrackIds?.indexOf(track?.id) > -1"
						class="is-left"
						(onUpdateIgnoreShowChange)="onUpdateIgnoreShow($event)"
						(onTimepointChange)="changeInOutPoint(ioPoint, $event, ioPoint.outpoint, 'in')">
					</timepoint>
					<track-element
						class="track-element"
						[class.selected]="widget?.isSelected"
						[ngStyle]="getIOPointStyles( ioPoint )"
						[style.cursor]="dragDisabled ? 'default' : 'move'"
						[widget]="widget"
						(click)="onInOutPointClick($event, ioPoint)"
						(contextmenu)="onTrackElementContextMenu($event, ioPoint)"
						(mousedown)="onTrackElementMouseDown($event)"
						bbDrag
						[bbDragUseSnapping]="useSnapping"
						[bbDragSnapCoords]="snappingTargets"
						[bbDragRelativeSnapPoints]="[{x: 0, y: 0}, {x: 1, y: 0}]"
						[bbDragDisabled]="dragDisabled"
						[bbDragAxis]="'x'"
						[bbDragContainer]="trackElementContainer"
						(bbDragStarted)="onTrackElementDragStarted(ioPoint, $event)"
						(bbDragEnded)="onTrackElementDragEnd(ioPoint, $event)"
						bbResize
						(bbResizeStarted)="onTrackResizeStart(widget, $event)"
						(bbResized)="onTrackResizeEvent(ioPoint, $event)"
						(bbResizeEnded)="onTrackResizeEvent(ioPoint, $event)"
						[bbResizeSnapCoords]="snappingTargets"
						[bbResizeUseSnapping]="useSnapping"
						[bbResizeUsePct]="true"
						[bbResizeContainer]="trackElementContainer"
						[bbResizeDisabled]="widget?.fromAppId"
						[bbResizeHandles]="resizeHandles"
						>
						<bb-resize-handles
							style="margin-left: -4px;"
							[hidden]="widget?.fromAppId"
							direction="horizontal"
							[invisibleHandles]="true"
							#resizeHandles
							(mousedown)="$event.stopPropagation()"
						></bb-resize-handles>
					</track-element>
					<timepoint
						[dragger]="'none'"
						[maxTime]="duration"
						[tooltip]="(rightData - leftData < 80) && (rightData > hideRightData) ? 'hide' : 'right'"
						[timepoint]="ioPoint.outpointTMP || ioPoint.outpoint"
						[widgetConfig]="widget?.config"
						[ngStyle]="tooltipRightOffset( ioPoint.outpointTMP || ioPoint.outpoint )"
						[class.track-selected]="selectedTrackIds?.indexOf(track?.id) > -1 && rightData < hideRightData"
						[class.display-right-over-track]="rightData > hideRightData"
						class= "is-right"
						(onUpdateIgnoreHideChange)="onUpdateIgnoreHide($event)"
						(onTimepointChange)="changeInOutPoint(ioPoint, ioPoint.inpoint, $event, 'out')">
					</timepoint>
				</ng-container>
			</div>
		</div>
	</ng-template>
	<ng-container *ngIf="!trackCollapsed">
		<ng-container *ngFor="let config of animateConfig; let i = index; trackBy: trackByForTimepointTrack ">
			<timepoint-track 
				[widgetId]="widget?.id" 
				[timepointConfig]="config" 
				[theme]="'subtrack-theme'" 
				[tooltip]="'right'" 
				[dragger]="'keyframe'"
				[trackIndex]="i" 
				(onDragging)="timepointDragging = $event">
			</timepoint-track>
		</ng-container>
	</ng-container>
</div>
